import { FC } from 'react';

import { Link, LinkProps } from 'react-scroll';

const ScrollLink: FC<LinkProps> = ({
  children,
  activeClass = 'active',
  className,
  spy = true,
  smooth = true,
  duration = 500,
  to,
}) => (
  <Link
    activeClass={activeClass}
    className={className}
    to={to}
    spy={spy}
    smooth={smooth}
    duration={duration}
    offset={-100}
  >
    {children}
  </Link>
);

export default ScrollLink;
